document.addEventListener("DOMContentLoaded", function () {
    const modal = document.getElementById("swatchModal");
    const closeSwatches = document.getElementById("closeSwatches");
    const openSwatches = document.querySelector('a[title="View Fabric Options"]'); // Adjust selector if needed

    // Open modal when clicking the link
    if (openSwatches) {
        openSwatches.addEventListener("click", function (event) {
            event.preventDefault(); // Prevent default link behavior
            modal.style.display = "block"; // Show the modal
        });
    }

    // Close modal when clicking the close button
    if (closeSwatches) {
        closeSwatches.addEventListener("click", function () {
            modal.style.display = "none"; // Hide the modal
        });
    }

    // Close modal when clicking outside the modal content
    modal.addEventListener("click", function (event) {
        const content = document.querySelector(".swatch-content");
        if (!content.contains(event.target)) {
            modal.style.display = "none"; // Hide the modal
        }
    });
});
